/// <reference types="./node.d.mts" />
import * as $global from "../../../ds/web/javascript/global.mjs";
import { Ok } from "../../gleam.mjs";
import {
  questionsContainerHeight as questions_container_height,
  onResize as on_resize,
} from "./node.ffi.mjs";

export { on_resize, questions_container_height };

function do_retry(times, current, run) {
  let $ = run();
  if ($ instanceof Ok) {
    return undefined;
  } else if (times === current) {
    return undefined;
  } else {
    $global.set_timeout(
      100,
      () => { return do_retry(times, current + 1, run); },
    );
    return undefined;
  }
}

export function retry(times, run) {
  return do_retry(times, 0, run);
}

export function timeout(timeout, run) {
  $global.set_timeout(timeout, run);
  return undefined;
}
